import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const cameraLiveSlice = createSlice({
  name: 'cameraLive',
  initialState: {
    liveState: {
      liveConfig: '',
      liveCameraUrl: '',
      liveModel: '',
      liveWorkflow: ''
    },
    previousModel: '',
    previousWorkflow: null,
    workflowId: null,
    cameraId: '',
    inferenceTriggered: false,
    lastTriggerTimestamp: 0
  },
  reducers: {
    setLiveState: (state, action) => {
      state.liveState = action.payload;
    },
    setPreviousModel: (state, action) => {
      state.previousModel = action.payload;
    },
    setCameraId: (state, action) => {
      state.cameraId = action.payload;
    },
    setWorkflowId: (state, action) => {
      state.workflowId = action.payload;
    },
    setPreviousWorkflow: (state, action) => {
      state.previousWorkflow = action.payload;
    },
    setInferenceTriggered: (state, action) => {
      state.inferenceTriggered = action.payload;

      if (action.payload === true) {
        state.lastTriggerTimestamp = Date.now();
      }
    }
  }
});

export const {
  setLiveState,
  setPreviousModel,
  setPreviousWorkflow,
  setCameraId,
  setWorkflowId,
  setInferenceTriggered
} = cameraLiveSlice.actions;
export default cameraLiveSlice.reducer;
